import KubernetesImg from "public/kubernetes/Kubernetes.png";

export const INTRO_CONSTANTS = {
  title: "Enterprise Kubernetes Without the Headaches ",
  description:
    "OneMind’s Kubernetes-as-a-Service streamlines the full lifecycle of K8s clusters—from provisioning to scaling—on a secure, cloud-native control plane powered by Taikun. ",
  points: [
    "CNCF-compliant Kubernetes distribution",
    "Fully managed control plane with 99.99% uptime",
    "Public cluster support with fine-grained RBAC",
    "Native auto-scaling for workloads and nodes",
    "Seamless integration with GitOps and CI/CD workflows",
  ],
  image: KubernetesImg,
  imageHeight: "370px",
};
